<template>
  <div id="hydwldsh">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hydwldsh'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/leaderApprove/company/Hydwldsh.vue